import React, { useState, useEffect } from "react";
import { Box, Progress } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import { getCachedConfig } from '../utils/configManager';

interface MobileProgressBarProps {
  currentStep: number;
  totalSteps: number;
  showExistingPatientStep?: boolean; // New prop to control step visibility
}

// Wrap the component with observer to make it reactive to MobX changes
const MobileProgressBar: React.FC<MobileProgressBarProps> = observer(({
  currentStep,
  totalSteps,
  showExistingPatientStep = true // Default to showing the step if not specified
}) => {
  // Adjust step calculation based on whether Existing Patient step is shown
  const adjustedCurrentStep = React.useMemo(() => {
    // If showing all steps, use currentStep as is
    if (showExistingPatientStep) {
      return currentStep;
    }

    // If Existing Patient step is hidden and we're past it,
    // we need to add 1 to display the correct progress
    if (currentStep > 1) {
      return currentStep - 1;
    }

    return currentStep;
  }, [currentStep, showExistingPatientStep]);

  // Calculate progress percentage
  const totalStepsAdjusted = totalSteps - (showExistingPatientStep ? 0 : 1);
  const progressPercentage = (adjustedCurrentStep / totalStepsAdjusted) * 100;

  const [config, setConfig] = useState<any>(null);
  const colors = config?.colorScheme || {};

  useEffect(() => {
    const config = getCachedConfig();
    if (config) {
      setConfig(config);
    }
  }, []);

  return (
    <Box width="100%" mb={4}>
      <Progress
        value={progressPercentage}
        size="sm"
        borderRadius="md"
        sx={{
          '& > div': {
            backgroundColor: colors.buttonBg,
          },
        }}
      />

    </Box>
  );
});

export default MobileProgressBar;